import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { templateContratoEditRoute } from '../../library/Routes';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import { Col } from '../Col';
import { Row } from '../Row';
import moment from 'moment';
import styles from './TemplateContratoItem.scss';

const rootClassName = styles.rootClassName;

class TemplateContratoItem extends Component {
  toEdit = () => {
    this.props.history.push(
      templateContratoEditRoute.getURLWithParams(this.props.template.id)
    );
  };

  render() {
    const data = this.props.template.dataAlteracao
      ? moment(this.props.template.dataAlteracao).format('DD/MM/YYYY HH:mm')
      : '';

    return (
      <Row>
        <Col cols={[12, 12, 12, 12, 12]} className={rootClassName + '-col'}>
          <div className={rootClassName}>
            <button
              className={getMergedClassNames([
                rootClassName + '-item-button',
                this.props.auth.userPermissions.contratos.assessor.templates
                  .edit
                  ? ''
                  : rootClassName + '-disabled-item-button',
              ])}
              onClick={() => {
                if (
                  this.props.auth.userPermissions.contratos.assessor.templates
                    .edit
                ) {
                  this.toEdit();
                }
              }}
            >
              <span>{this.props.template.nome}</span>
              <span>
                {this.props.languageValues.lastModification}
                {data}
              </span>
            </button>
          </div>
        </Col>
      </Row>
    );
  }
}

TemplateContratoItem.propTypes = {
  template: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TemplateContratoItem));
